'use strict';

// References
var alt = require('../alt');
var NotificationActions = require('../actions/NotificationActions');
var _ = require('underscore');

class NotificationStore {
    // Data
    constructor() {
        this.bindActions(NotificationActions);
        this.notification = {};
    }

    onClearNotification(){
        this.notification = {};
    }

    onCreateNotification(data){
      console.log('test', data);

        var notification = {
            title: data.title,
            message: data.message,
            level: data.level
        }
        this.notification = notification;
    }

}

var notificationStore = alt.createStore(NotificationStore, 'NotificationStore');

window.notificationStore = notificationStore;

module.exports = notificationStore;



// WEBPACK FOOTER //
// ./app/scripts/stores/NotificationStore.js